import React, { useEffect, useRef, useState } from 'react';
import { BuildPath } from '../../../helpers/Paths';
import { UserImportType } from  '@/models/UserImportType';

interface Step1Props {
    setUploadType: (type: UserImportType) => void
    uploadType: UserImportType
}

const Step1 = ({ setUploadType, uploadType }: Step1Props) => {

    return (
        <React.Fragment>
            <div className='uploadtype-btns'>
                <div onClick={() => setUploadType(UserImportType.Fullsync)} className={`uploadtype-btn ${uploadType === UserImportType.Fullsync? 'active' : ''}`}>
                    <div className="uploadtype-btn-wrapper">
                        <input type="radio" name="uploadtype" value={UserImportType.Fullsync} checked={uploadType === UserImportType.Fullsync} onChange={() => setUploadType(UserImportType.Fullsync)} />
                        <div className="uploadtype-btn-text-wrapper">
                            <div className="uploadtype-btn-title">
                                Full Sync
                            </div>
                            <div className='uploadtype-btn-desc'>
                                Sync all users with details on CSV file.
                            </div>
                        </div>
                    </div>
                </div>
                <div onClick={() => setUploadType(UserImportType.Starters)} className={`uploadtype-btn ${uploadType === UserImportType.Starters ? 'active' : ''}`}>
                    <div className="uploadtype-btn-wrapper">
                        <input type="radio" name="uploadtype" value={UserImportType.Starters} checked={uploadType === UserImportType.Starters} onChange={() => setUploadType(UserImportType.Starters)} />
                        <div className="uploadtype-btn-text-wrapper">
                            <div className="uploadtype-btn-title">
                                Starters
                            </div>
                            <div className='uploadtype-btn-desc'>
                                Add all users from CSV file.
                            </div>
                        </div>
                    </div>
                </div>
                <div onClick={() => setUploadType(UserImportType.Leavers)} className={`uploadtype-btn ${uploadType == UserImportType.Leavers ? 'active' : ''}`}>
                    <div className="uploadtype-btn-wrapper">
                        <input type="radio" name="uploadtype" value={UserImportType.Leavers} checked={uploadType == UserImportType.Leavers} onChange={() => setUploadType(UserImportType.Leavers)} />
                        <div className="uploadtype-btn-text-wrapper">
                            <div className="uploadtype-btn-title">
                                Leavers
                            </div>
                            <div className='uploadtype-btn-desc'>
                                Deactivate all users from CSV file.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
};

export default Step1;